module.exports = __webpack_public_path__ + "img/8.6.CODm.36af2e29.png";